// Dynamic styles based on theme - to be used with useThemedStyles.
export const createMachineSetupDetailStyles = ({ ui: { colors, type, space } }) => ({
	scrollView: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	content: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
		paddingBottom: space.xl,
		gap: space.lg,
	},
	headingBlock: {
		gap: 6,
	},
	statusBadge: {
		marginTop: space.xs,
	},
	loaderContainer: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
	},
	fieldLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginTop: space.md,
		marginBottom: 6,
	},
	requiredAsterisk: {
		color: colors.danger,
	},
	fieldHint: {
		...type.secondary,
		color: colors.textSecondary,
		marginBottom: space.sm,
	},
	sectionLabel: {
		...type.rowTitleSemibold,
		color: colors.text,
		marginTop: space.lg,
		marginBottom: space.sm,
	},
	photoHint: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: -space.xs,
		marginBottom: space.lg,
	},
	subheadingSmall: {
		...type.bodySmallSemibold,
		color: colors.text,
		marginTop: space.md,
		marginBottom: 6,
	},
	planogramPreview: {
		marginTop: space.sm,
		marginBottom: space.md,
	},
});
